<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
  <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>
<div class="mbr">
  <header class="mbr__page-head">
    <div class="mbr__copy">
      <h1 class="mbr__title">Manpower Budget Report</h1>
      <p class="mbr__subtitle">
        View manpower and cost details with actuals based on selected filters. Filters can be applied from the right panel.
      </p>
    </div>
    <div class="mbr__page-actions">
      <span class="mbr__updated">
        <img [src]="icons.update" alt="" width="14" height="14" />
        Last Updated : {{ lastUpdated }}
      </span>
      <button type="button" class="mbr__filter-btn" (click)="openCustomizeFilterDialog()">
        <img [src]="icons.funnel" alt="" width="14" height="14" />
        Filters ({{ filterCount }})
      </button>
    </div>
  </header>

  <section class="mbr__kpis" aria-label="Summary cards">
    <article class="mbr__kpi">
      <div class="mbr__tile mbr__tile--violet">
        <img [src]="icons.usersViolet" alt="" width="25" height="25" />
      </div>
      <p class="mbr__kpi-label">Total Budgeted Positions</p>
      <p class="mbr__kpi-value">{{ kpis.totalBudgeted }}</p>
      <p class="mbr__kpi-hint">Total approved positions</p>
    </article>

    <article class="mbr__kpi">
      <div class="mbr__tile mbr__tile--green">
        <img [src]="icons.usersGreen" alt="" width="25" height="25" />
      </div>
      <p class="mbr__kpi-label">Filled Positions</p>
      <p class="mbr__kpi-value">{{ kpis.filled }}</p>
      <p class="mbr__kpi-hint">Currently filled positions</p>
    </article>

    <article class="mbr__kpi">
      <div class="mbr__tile mbr__tile--orange">
        <img [src]="icons.usersOrange" alt="" width="25" height="25" />
      </div>
      <p class="mbr__kpi-label">Position Balance</p>
      <p class="mbr__kpi-value">{{ kpis.positionBalance }}</p>
      <p class="mbr__kpi-status">
        <img [src]="icons.arrowDown" alt="" width="14" height="14" />
        Within Budget
      </p>
    </article>

    <article class="mbr__kpi">
      <div class="mbr__tile mbr__tile--blue">
        <img [src]="icons.rupee" alt="" width="25" height="25" />
      </div>
      <p class="mbr__kpi-label">Total Budget</p>
      <p class="mbr__kpi-value mbr__kpi-value--cr">{{ formatCompactInr(kpis.totalBudget) }}</p>
      <p class="mbr__kpi-hint">Allocated amount</p>
    </article>

    <article class="mbr__kpi">
      <div class="mbr__tile mbr__tile--teal">
        <img [src]="icons.wallet" alt="" width="25" height="25" />
      </div>
      <p class="mbr__kpi-label">Utilized Budget</p>
      <p class="mbr__kpi-value mbr__kpi-value--cr">{{ formatCompactInr(kpis.utilizedBudget) }}</p>
      <p class="mbr__kpi-status">
        <img [src]="icons.arrowDown" alt="" width="14" height="14" />
        Within Budget
      </p>
    </article>

    <article class="mbr__kpi">
      <div class="mbr__tile mbr__tile--rose">
        <img [src]="icons.barChart" alt="" width="25" height="25" />
      </div>
      <p class="mbr__kpi-label">Budget Balance</p>
      <p class="mbr__kpi-value mbr__kpi-value--cr">{{ formatCompactInr(kpis.budgetBalance) }}</p>
      <p class="mbr__kpi-status">
        <img [src]="icons.arrowDown" alt="" width="14" height="14" />
        Within Budget
      </p>
    </article>
  </section>

  <section class="mbr__charts">
    <article class="mbr__chart">
      <div class="mbr__chart-head">
        <div class="mbr__mini-tile">
          <img [src]="icons.mapPin" alt="" width="16" height="16" />
        </div>
        <h2>Position Overview</h2>
      </div>
      <div class="mbr__plot">
        <div class="mbr__axis">
          <span *ngFor="let tick of positionAxisTicks">{{ tick }}</span>
        </div>
        <div class="mbr__bars">
          <div class="mbr__bar-col">
            <span>{{ kpis.totalBudgeted }}</span>
            <div class="mbr__bar-track">
              <div class="mbr__bar mbr__bar--blue" [style.height]="barHeight(kpis.totalBudgeted, positionBarMax)"></div>
            </div>
            <small>Budgeted</small>
          </div>
          <div class="mbr__bar-col">
            <span>{{ kpis.filled }}</span>
            <div class="mbr__bar-track">
              <div class="mbr__bar mbr__bar--green" [style.height]="barHeight(kpis.filled, positionBarMax)"></div>
            </div>
            <small>Filled</small>
          </div>
          <div class="mbr__bar-col">
            <span>{{ kpis.positionBalance }}</span>
            <div class="mbr__bar-track">
              <div class="mbr__bar mbr__bar--orange" [style.height]="barHeight(kpis.positionBalance, positionBarMax)"></div>
            </div>
            <small>Vacant</small>
          </div>
        </div>
      </div>
    </article>

    <article class="mbr__chart">
      <div class="mbr__chart-head">
        <div class="mbr__mini-tile">
          <img [src]="icons.blocks" alt="" width="16" height="16" />
        </div>
        <h2>Budget Overview <span>(₹ In Crores)</span></h2>
      </div>
      <div class="mbr__plot">
        <div class="mbr__axis">
          <span *ngFor="let tick of budgetAxisTicks">{{ tick | number : '1.0-2' }}</span>
        </div>
        <div class="mbr__bars">
          <div class="mbr__bar-col">
            <span>{{ kpis.totalBudgetCr | number : '1.2-2' }}</span>
            <div class="mbr__bar-track">
              <div class="mbr__bar mbr__bar--blue" [style.height]="barHeight(kpis.totalBudgetCr, budgetBarMax)"></div>
            </div>
            <small>Total Budget</small>
          </div>
          <div class="mbr__bar-col">
            <span>{{ kpis.utilizedBudgetCr | number : '1.2-2' }}</span>
            <div class="mbr__bar-track">
              <div class="mbr__bar mbr__bar--green" [style.height]="barHeight(kpis.utilizedBudgetCr, budgetBarMax)"></div>
            </div>
            <small>Utilized</small>
          </div>
          <div class="mbr__bar-col">
            <span>{{ kpis.budgetBalanceCr | number : '1.2-2' }}</span>
            <div class="mbr__bar-track">
              <div class="mbr__bar mbr__bar--orange" [style.height]="barHeight(kpis.budgetBalanceCr, budgetBarMax)"></div>
            </div>
            <small>Balance</small>
          </div>
        </div>
      </div>
    </article>

    <article class="mbr__chart mbr__chart--status">
      <div class="mbr__chart-head">
        <div class="mbr__mini-tile">
          <img [src]="icons.dashboard" alt="" width="16" height="16" />
        </div>
        <h2>Position vs Budget Status</h2>
      </div>
      <div class="mbr__donuts">
        <div class="mbr__donut-wrap">
          <div class="mbr__donut" [ngStyle]="positionDonutStyle">
            <div class="mbr__donut-hole">{{ positionPct }}%</div>
          </div>
          <p>Positions</p>
          <div class="mbr__legend">
            <div>
              <img [src]="icons.markerGreen" alt="" width="9" height="9" />
              <span>Within Limit</span>
              <b>{{ positionStatus.within }}</b>
            </div>
            <div>
              <img [src]="icons.markerRed" alt="" width="9" height="9" />
              <span>Exceeded</span>
              <b>{{ positionStatus.exceeded }}</b>
            </div>
          </div>
        </div>
        <div class="mbr__divider"></div>
        <div class="mbr__donut-wrap">
          <div class="mbr__donut" [ngStyle]="budgetDonutStyle">
            <div class="mbr__donut-hole">{{ budgetPct }}%</div>
          </div>
          <p>Budget</p>
          <div class="mbr__legend">
            <div>
              <img [src]="icons.markerGreen" alt="" width="9" height="9" />
              <span>Within Limit</span>
              <b>{{ budgetStatus.within }}</b>
            </div>
            <div>
              <img [src]="icons.markerRed" alt="" width="9" height="9" />
              <span>Exceeded</span>
              <b>{{ budgetStatus.exceeded }}</b>
            </div>
          </div>
        </div>
      </div>
    </article>
  </section>

  <section class="mbr__table-card">
    <div class="mbr__table-head">
      <div class="mbr__table-title">
        <div class="mbr__table-icon">
          <img [src]="icons.chartNetwork" alt="" width="15" height="15" />
        </div>
        <h2>Position Wise Details</h2>
      </div>
      <div class="mbr__table-tools">
        <label class="mbr__search">
          <img [src]="icons.search" alt="" width="13" height="13" />
          <input type="search" placeholder="Search position, designation..." [(ngModel)]="searchText" />
        </label>
        <button type="button" class="mbr__export" (click)="exportCsv()">Export</button>
      </div>
    </div>

    <div class="mbr__table-wrap">
      <ag-grid-angular
        class="ag-theme-alpine mbr__grid"
        [rowData]="filteredRows"
        [columnDefs]="columnDefs"
        [defaultColDef]="defaultColDef"
        [autoGroupColumnDef]="autoGroupColumnDef"
        [pinnedBottomRowData]="pinnedBottomRowData"
        [quickFilterText]="searchText"
        [overlayNoRowsTemplate]="overlayNoRowsTemplate"
        [animateRows]="true"
        [groupDisplayType]="'singleColumn'"
        [groupDefaultExpanded]="0"
        [suppressAggFuncInHeader]="true"
        [suppressCellFocus]="true"
        [rowHeight]="38"
        [headerHeight]="40"
        (gridReady)="onGridReady($event)"
      >
      </ag-grid-angular>
    </div>
  </section>
</div>
